// import { useEffect, useState, useCallback } from "react";
// import { toast } from "react-toastify";
// import { getOrganizationsApi } from "../../apis/organizationApi";

// export const useOrganizations = (filters, page, pageSize, enabled = true) => {
//   const [organizations, setOrganizations] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const fetchOrganizations = useCallback(async (silent = false) => {
//     if (!enabled) return;

//     setLoading(true);
//     setError(null);

//     let toastId = null;
//     if (!silent) {
//       toastId = toast.loading("Loading organizations...");
//     }

//     try {
//       const data = await getOrganizationsApi(filters, page, pageSize);
//       setOrganizations(data.data || []);

//       if (toastId) {
//         toast.update(toastId, {
//           render: "Organizations loaded",
//           type: "success",
//           isLoading: false,
//           autoClose: 1500, // very short for list loads
//         });
//       }
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to load organizations. Please try again.";

//       if (toastId) {
//         toast.update(toastId, {
//           render: errorMessage,
//           type: "error",
//           isLoading: false,
//         });
//       } else {
//         toast.error(errorMessage);
//       }

//       setError(errorMessage);
//       console.error("Error fetching organizations:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [filters, page, pageSize, enabled]);

//   useEffect(() => {
//     fetchOrganizations(true); // silent on initial load
//   }, [fetchOrganizations]);

//   return { organizations, setOrganizations, loading, error, refetch: () => fetchOrganizations(false) };
// };


import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { getOrganizationsApi } from "../../apis/organizationApi";

export const useOrganizations = (
  filters,
  page,
  pageSize,
  enabled = true
) => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
    const res = err.response?.data;

    return {
      title: res?.message || "Load Failed",
      issue:
        res?.data ||
        err.message ||
        "Failed to load organizations. Please try again.",
    };
  };

  const fetchOrganizations = useCallback(
    async (silent = false) => {
      if (!enabled) return;

      setLoading(true);
      setError(null);

      let toastId = null;

      if (!silent) {
        toastId = toast.loading("Loading organizations...");
      }

      try {
        const response = await getOrganizationsApi(
          filters,
          page,
          pageSize
          );
        setOrganizations(response.data || []);

        if (toastId) {
          toast.update(toastId, {
            render: (
              <div>
                <strong>Organizations Loaded</strong>
                <div>List updated successfully.</div>
              </div>
            ),
            type: "success",
            isLoading: false,
            autoClose: 1500,
          });
        }
      } catch (err) {
        const { title, issue } = extractError(err);

        if (toastId) {
          toast.update(toastId, {
            render: (
              <div>
                <strong>{title}</strong>
                <div>{issue}</div>
              </div>
            ),
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
        } else {
          toast.error(
            <div>
              <strong>{title}</strong>
              <div>{issue}</div>
            </div>
          );
        }

        setError({ title, issue });
        console.error("Error fetching organizations:", err);
      } finally {
        setLoading(false);
      }
    },
    [filters, page, pageSize, enabled]
  );

  useEffect(() => {
    fetchOrganizations(true); // silent on initial load
  }, [fetchOrganizations]);

  return {
    organizations,
    setOrganizations,
    loading,
    error,
    refetch: () => fetchOrganizations(false),
  };
};